module.exports = __webpack_public_path__ + "img/bundles.74fcd59d.svg";